import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from '@cbridge-utils/react-redux';
import { NavigationBlock, NavigationBlockRecursiveItem } from '@cbridge-tools/navigation-block';
import { clientSymbolNodesSubNavigationPropsSelector } from './ClientSymbolNodesSubNavigation.selector';

export const ClientSymbolNodesSubNavigation: FC = () => {
  const { t } = useTranslation();

  const { items, isLoading } = useSelector(clientSymbolNodesSubNavigationPropsSelector);

  return (
    <NavigationBlock
      header={t('text:configPage.streams.section.tradingServers')}
      items={items}
      isLoading={isLoading}
      NavigationItemComponent={NavigationBlockRecursiveItem}
    />
  );
};
